/* Přepínač centimetrů a palců u velikostí (2026-09-19 na přání majitelky:
   „ty palce a cm ať může uživatel přepínat").

   PROČ SKRIPTEM: velikosti jsou názvy variant a přicházejí ze Shopify
   v centimetrech. Přepočítat je v šabloně by znamenalo sahat do konfigurátoru;
   takhle se jen přepíše popisek v dlaždici a volba varianty zůstane netknutá.

   POZOR NA TO, ŽE DLAŽDICE NEJSOU V HTML: konfigurátor je skládá až
   v prohlížeči a přeskládá je pokaždé, když návštěvník změní materiál nebo
   provedení (jiný materiál = jiná nabídka velikostí). Proto se tu hlídají
   změny a popisky se přepisují znovu — jednorázový průchod by po první změně
   materiálu přestal platit.

   ZAOKROUHLENÍ: 60 cm je přesně 23,6 palce. Zlomky v dlaždicích vypadají
   hrozně, proto se zaokrouhluje na celé palce a pod řadou se objeví věta, že
   závazný rozměr je v centimetrech. Nechci, aby si někdo objednal „24 palců"
   a divil se, že dostal 23,6. Přesná hodnota je v bublině po najetí myší.

   Souhrn pod konfigurátorem zůstává v centimetrech schválně — je to název
   varianty tak, jak ho vede Shopify, a ten se přepisovat nemá. */
(function () {
  'use strict';

  var KLIC = 'galelie-jednotky';
  var PALEC_CM = 2.54;

  var TEXTY = {
    cs: { pozn: 'Palce jsou zaokrouhlené. Závazný rozměr je v centimetrech.', prepnout: 'Jednotky' },
    en: { pozn: 'Inches are rounded. The binding size is in centimetres.', prepnout: 'Units' },
    de: { pozn: 'Zoll sind gerundet. Verbindlich ist das Maß in Zentimetern.', prepnout: 'Einheiten' },
    es: { pozn: 'Las pulgadas están redondeadas. La medida vinculante es en centímetros.', prepnout: 'Unidades' },
    fr: { pozn: 'Les pouces sont arrondis. La taille contractuelle est en centimètres.', prepnout: 'Unités' },
    it: { pozn: 'I pollici sono arrotondati. La misura vincolante è in centimetri.', prepnout: 'Unità' },
    nl: { pozn: 'Inches zijn afgerond. De bindende maat is in centimeters.', prepnout: 'Eenheden' },
    pl: { pozn: 'Cale są zaokrąglone. Wiążący wymiar podajemy w centymetrach.', prepnout: 'Jednostki' },
    pt: { pozn: 'As polegadas são arredondadas. A medida vinculativa é em centímetros.', prepnout: 'Unidades' },
    hu: { pozn: 'A hüvelyk kerekített. A mérvadó méret centiméterben van.', prepnout: 'Mértékegység' },
    uk: { pozn: 'Дюйми округлені. Обов’язковий розмір — у сантиметрах.', prepnout: 'Одиниці' }
  };

  function texty() {
    var kod = (document.documentElement.lang || 'cs').slice(0, 2).toLowerCase();
    return TEXTY[kod] || TEXTY.cs;
  }

  function nactiVolbu() {
    try {
      return window.localStorage.getItem(KLIC) === 'in' ? 'in' : 'cm';
    } catch (e) {
      return 'cm';
    }
  }

  function ulozVolbu(v) {
    try {
      window.localStorage.setItem(KLIC, v);
    } catch (e) {
      /* Bez úložiště se volba jen nezapamatuje do příště. */
    }
  }

  function naPalce(text) {
    var m = text.match(/(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;
    var a = Math.round(parseFloat(m[1].replace(',', '.')) / PALEC_CM);
    var b = Math.round(parseFloat(m[2].replace(',', '.')) / PALEC_CM);
    if (!a || !b) return null;
    return a + ' × ' + b + ' in';
  }

  var jednotka = nactiVolbu();
  var t = texty();
  var prepinac = null;
  var poznamka = null;
  // Vlastní přepisy nesmí spustit další kolo hlídání.
  var prepisuju = false;

  function postavOvladani() {
    if (!prepinac) {
      prepinac = document.createElement('div');
      prepinac.className = 'jednotky';
      prepinac.setAttribute('role', 'group');
      prepinac.setAttribute('aria-label', t.prepnout);

      ['cm', 'in'].forEach(function (kod) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jednotky-volba';
        b.setAttribute('data-jednotka', kod);
        b.setAttribute('aria-pressed', 'false');
        b.textContent = kod;
        b.addEventListener('click', function () {
          jednotka = kod;
          ulozVolbu(kod);
          vykresli();
        });
        prepinac.appendChild(b);
      });
    }

    if (!poznamka) {
      poznamka = document.createElement('p');
      poznamka.className = 'jednotky-pozn';
      poznamka.textContent = t.pozn;
      poznamka.hidden = true;
    }

    var rada = document.querySelector('.pc-sizes');
    if (!rada) return false;

    // Konfigurátor umí celý krok přestavět; pak je potřeba ovládání vrátit.
    var krok = rada.closest('.pc-step');
    var legenda = krok && krok.querySelector('.pc-legend');
    if (legenda && prepinac.parentElement !== legenda) legenda.appendChild(prepinac);
    else if (!legenda && prepinac.parentElement !== rada.parentElement) {
      rada.parentElement.insertBefore(prepinac, rada);
    }
    if (poznamka.parentElement !== rada.parentElement) {
      rada.parentElement.insertBefore(poznamka, rada.nextSibling);
    }
    return true;
  }

  function vykresli() {
    var popisky = document.querySelectorAll('.pc-size-label');
    if (!popisky.length) return;

    prepisuju = true;

    Array.prototype.forEach.call(popisky, function (el) {
      // Původní text se schová do atributu, ať se dá kdykoli vrátit beze ztrát.
      if (!el.hasAttribute('data-cm')) el.setAttribute('data-cm', el.textContent.trim());
      var cm = el.getAttribute('data-cm') || '';
      if (jednotka === 'in') {
        var palce = naPalce(cm);
        el.textContent = palce || cm;
        el.title = cm;
      } else {
        el.textContent = cm;
        el.removeAttribute('title');
      }
    });

    if (prepinac) {
      Array.prototype.forEach.call(prepinac.children, function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-jednotka') === jednotka ? 'true' : 'false');
      });
    }
    if (poznamka) poznamka.hidden = jednotka !== 'in';

    // Až po překreslení, jinak by se hlídač spustil na vlastní změny.
    window.setTimeout(function () { prepisuju = false; }, 0);
  }

  function srovnej() {
    if (prepisuju) return;
    if (postavOvladani()) vykresli();
  }

  /* ------------------------------------------------- start a hlídání */

  var pc = document.querySelector('.pc');
  if (!pc) return;

  srovnej();

  // Konfigurátor přeskládá dlaždice při změně materiálu nebo provedení.
  if (window.MutationObserver) {
    new window.MutationObserver(srovnej).observe(pc, { childList: true, subtree: true });
  }
})();
